import { z } from "zod";

export const authProviderSchema = z.enum(["mock", "google"]);
export type AuthProvider = z.infer<typeof authProviderSchema>;

export const authConfigResponseSchema = z.object({ provider: authProviderSchema });
export type AuthConfigResponse = z.infer<typeof authConfigResponseSchema>;

/** 開発用モックログイン。AUTH_PROVIDER=mock のときのみ API が受け付ける。 */
export const mockLoginRequestSchema = z.object({
  email: z.email(),
  displayName: z.string().min(1).optional(),
});
export type MockLoginRequest = z.infer<typeof mockLoginRequestSchema>;

export const loginFailureReasonSchema = z.enum([
  "DOMAIN_NOT_ALLOWED",
  "NOT_REGISTERED",
  "NOT_ALLOWED",
  "ACCOUNT_MISMATCH",
]);
export type LoginFailureReason = z.infer<typeof loginFailureReasonSchema>;
